import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "assettype"
    }}>{`AssetType`}</h1>
    <p>{`Asset type options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`IMAGE_TYPE`}</strong>{` = 1952409965`}</p>
      <p parentName="blockquote">{`The asset is cataloged as an image asset.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`EPS_TYPE`}</strong>{` = 1952400720`}</p>
      <p parentName="blockquote">{`The asset is cataloged as an EPS asset.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PDF_TYPE`}</strong>{` = 1952403524`}</p>
      <p parentName="blockquote">{`The asset is cataloged as a PDF asset.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GEOMETRY_TYPE`}</strong>{` = 1952409445`}</p>
      <p parentName="blockquote">{`The asset is cataloged as a geometric page item asset.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PAGE_TYPE`}</strong>{` = 1952411745`}</p>
      <p parentName="blockquote">{`The asset is cataloged as a page asset.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TEXT_TYPE`}</strong>{` = 1952412773`}</p>
      <p parentName="blockquote">{`The asset is cataloged as a text asset.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`STRUCTURE_TYPE`}</strong>{` = 1952412532`}</p>
      <p parentName="blockquote">{`Structure asset`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INDESIGN_FILE_TYPE`}</strong>{` = 1952409956`}</p>
      <p parentName="blockquote">{`InDesign file asset`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      